(function () {
  'use strict';

  // Varias secciones incluyen este archivo, así que en una misma página puede
  // cargarse más de una vez. Sin este cerrojo se duplicarían los listeners y,
  // por ejemplo, el botón de sonido se activaría y desactivaría a la vez.
  if (window.__mtScriptsCargado) return;
  window.__mtScriptsCargado = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.getAttribute('data-mt-delay') || 0;
            setTimeout(function () {
              entry.target.classList.add('mt-visible');
            }, Number(delay));
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Count-up numbers ---------- */
  function initCountUp() {
    var els = document.querySelectorAll('[data-mt-countup]');
    if (!els.length) return;
    var run = function (el) {
      var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var decimals = target % 1 !== 0 ? 1 : 0;
      if (reduceMotion) {
        el.textContent = target.toFixed(decimals) + suffix;
        return;
      }
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Comparador antes/después ---------- */
  function initComparador() {
    var wraps = document.querySelectorAll('.mt-compare__wrap');
    wraps.forEach(function (wrap) {
      var after = wrap.querySelector('.mt-compare__after');
      var handle = wrap.querySelector('.mt-compare__handle');
      var range = wrap.querySelector('.mt-compare__range');
      if (!after || !range) return;
      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        if (handle) handle.style.left = pct + '%';
      }
      range.addEventListener('input', function () {
        setPos(Number(range.value));
      });
      setPos(Number(range.value || 50));
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria() {
    var galleries = document.querySelectorAll('[data-mt-gallery]');
    galleries.forEach(function (gallery) {
      var main = gallery.querySelector('[data-mt-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-mt-full');
          if (!src) return;
          main.src = src;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Reproducir en cuanto el vídeo tenga datos ---------- */
  function reproducirCuandoPueda(video) {
    if (!video) return;
    var intentar = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    intentar();
    if (video.readyState < 3) {
      video.addEventListener('canplay', intentar, { once: true });
      video.addEventListener('loadeddata', intentar, { once: true });
    }
  }

  /* ---------- Galería de la ficha nueva (visor + miniaturas) ---------- */
  function initGaleriaPdp() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      var diapos = galeria.querySelectorAll('[data-mt-diapo]');
      var minis = galeria.querySelectorAll('[data-mt-mini]');
      if (!diapos.length) return;

      function mostrar(indice) {
        diapos.forEach(function (d) {
          var activa = d.getAttribute('data-mt-diapo') === String(indice);
          d.classList.toggle('is-activa', activa);
          // Los vídeos que no se ven se paran: si no, suenan y gastan de fondo.
          var v = d.querySelector('video');
          if (v) {
            if (activa) { reproducirCuandoPueda(v); }
            else { v.pause(); }
          }
        });
        minis.forEach(function (m) {
          m.classList.toggle('is-activa', m.getAttribute('data-mt-mini') === String(indice));
        });
      }

      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          mostrar(m.getAttribute('data-mt-mini'));
        });
      });

      // El vídeo de la diapositiva inicial arranca aquí y no desde el
      // observador de initVideos: si el navegador no reporta intersección
      // (pestaña en segundo plano, panel oculto), aquella nunca llegaría a
      // reproducirse y la ficha abriría con un fotograma congelado.
      var inicial = galeria.querySelector('.mt-pdp__diapo.is-activa video');
      if (inicial) reproducirCuandoPueda(inicial);

      // Al cambiar de color, saltar a la foto de esa variante.
      galeria.__mtMostrarPorSrc = function (src) {
        if (!src) return;
        var nombre = src.split('?')[0].split('/').pop();
        for (var i = 0; i < diapos.length; i++) {
          var d = diapos[i].getAttribute('data-mt-src');
          if (d && d.split('?')[0].split('/').pop() === nombre) {
            mostrar(diapos[i].getAttribute('data-mt-diapo'));
            return;
          }
        }
      };
    });
  }

  /* ---------- Tramos de descuento por cantidad ---------- */
  function initTramos() {
    document.querySelectorAll('[data-mt-tramos]').forEach(function (caja) {
      var form = caja.closest('form') || document;
      var cantidad = form.querySelector('[data-mt-qty] input');
      var boton = form.querySelector('[data-mt-add-btn]');
      var tramos = caja.querySelectorAll('[data-mt-tramo-cantidad]');
      if (!tramos.length) return;

      function formatear(centimos) {
        return (centimos / 100).toLocaleString('es-ES', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }

      // El botón muestra el total del tramo elegido, no el precio unitario.
      function pintarBoton(tramo) {
        if (!boton || boton.disabled) return;
        var texto = boton.getAttribute('data-mt-add-text') || 'Añadir';
        var total = tramo && parseInt(tramo.getAttribute('data-mt-tramo-total'), 10);
        if (total > 0) boton.textContent = texto + ' · ' + formatear(total);
      }

      function marcar(origen) {
        var actual = parseInt(cantidad && cantidad.value, 10) || 1;
        var elegido = null;
        tramos.forEach(function (t) {
          var n = parseInt(t.getAttribute('data-mt-tramo-cantidad'), 10) || 0;
          var activo = n === actual;
          t.classList.toggle('is-activo', activo);
          var radio = t.querySelector('.mt-pdp__tramo-radio');
          if (radio) radio.checked = activo;
          if (activo) elegido = t;
        });
        // Si la cantidad no cae en ningún tramo, el botón vuelve al precio suelto.
        if (elegido) pintarBoton(elegido);
        else if (boton && origen === 'cantidad') {
          boton.dispatchEvent(new CustomEvent('mt:recalcular', { bubbles: true }));
        }
      }

      tramos.forEach(function (t) {
        t.addEventListener('click', function () {
          if (!cantidad) return;
          cantidad.value = parseInt(t.getAttribute('data-mt-tramo-cantidad'), 10) || 1;
          cantidad.dispatchEvent(new Event('change', { bubbles: true }));
          marcar('tramo');
        });
      });

      if (cantidad) {
        ['change', 'input'].forEach(function (ev) {
          cantidad.addEventListener(ev, function () { marcar('cantidad'); });
        });
        var cajaQty = form.querySelector('[data-mt-qty]');
        if (cajaQty) cajaQty.addEventListener('click', function () { setTimeout(function () { marcar('cantidad'); }, 0); });
      }

      // Cuando el selector de variantes reescribe el botón, hay que volver a
      // poner el total del tramo o se quedaría el precio de una sola unidad.
      document.addEventListener('mt:variante-actualizada', function () {
        setTimeout(function () { marcar('variante'); }, 0);
      });

      marcar('inicio');
      ocultarWidgetDeApp();
    });
  }

  /* ---------- Ocultar el widget duplicado de la app de packs ---------- */
  // La app pinta su propio bloque de tramos y le pone display:block en línea
  // con !important, así que no se puede tapar desde la hoja de estilos. Se
  // oculta desde aquí y se vigila por si vuelve a mostrarlo. No se elimina:
  // sus campos ocultos son los que hacen que Shopify aplique el descuento.
  function ocultarWidgetDeApp() {
    var caja = document.querySelector('#svelte-bundle-widget');
    if (!caja || !document.querySelector('[data-mt-tramos]')) return;

    function tapar() {
      if (caja.style.display !== 'none') {
        caja.style.setProperty('display', 'none', 'important');
      }
    }
    tapar();

    if ('MutationObserver' in window) {
      var obs = new MutationObserver(tapar);
      obs.observe(caja, { attributes: true, attributeFilter: ['style', 'class'] });
      // La app termina de montarse en los primeros segundos; después ya no toca.
      setTimeout(function () { obs.disconnect(); }, 12000);
    }
  }

  /* ---------- Selector de variantes ---------- */
  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-product-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variants-json]');
      if (!dataEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = form.querySelector('[data-mt-price]');
      var compareEl = form.querySelector('[data-mt-compare]');
      var addBtn = form.querySelector('[data-mt-add-btn]');
      var swatches = form.querySelectorAll('[data-mt-option-index]');
      if (!swatches.length) swatches = document.querySelectorAll('[data-mt-option-index]');
      // En la primera pasada NO se toca la galería: la ficha debe abrir por el
      // primer medio (el vídeo), no saltar a la foto de la variante por defecto.
      var primeraPasada = true;
      // Sirve tanto para la ficha antigua (.mt-producto__grid) como para la
      // nueva PDP en mosaico ([data-mt-producto]).
      var gallerySection = form.closest('[data-mt-producto]') || form.closest('.mt-producto__grid');
      var galleryMain = gallerySection ? gallerySection.querySelector('[data-mt-gallery-main]') : null;
      var galleryThumbs = gallerySection ? gallerySection.querySelectorAll('[data-mt-gallery-thumb]') : null;

      function currentSelection() {
        var selected = {};
        swatches.forEach(function (btn) {
          var elegido = btn.tagName === 'INPUT' ? btn.checked : btn.classList.contains('is-selected');
          if (elegido) {
            selected[btn.getAttribute('data-mt-option-index')] = btn.getAttribute('data-mt-value');
          }
        });
        return selected;
      }

      function findVariant() {
        var selected = currentSelection();
        return variants.find(function (v) {
          return Object.keys(selected).every(function (idx) {
            return v.options[Number(idx)] === selected[idx];
          });
        });
      }

      function formatMoney(cents) {
        return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      }

      function updateUI() {
        var variant = findVariant();
        // update disabled state of swatches sharing other selections
        var selected = currentSelection();
        swatches.forEach(function (btn) {
          var idx = btn.getAttribute('data-mt-option-index');
          var val = btn.getAttribute('data-mt-value');
          var testSelection = Object.assign({}, selected);
          testSelection[idx] = val;
          var possible = variants.some(function (v) {
            return Object.keys(testSelection).every(function (i) {
              return v.options[Number(i)] === testSelection[i];
            });
          });
          btn.disabled = !possible;
          if (btn.tagName === 'INPUT') {
            var etiqueta = btn.nextElementSibling;
            if (etiqueta) etiqueta.classList.toggle('is-disabled', !possible);
          }
        });

        if (!variant) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-mt-unavailable-text') || 'No disponible';
          }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            var texto = addBtn.getAttribute('data-mt-add-text') || 'Añadir al carrito';
            // En la PDP el botón lleva el precio incorporado ("Añadir · 29,99 €").
            if (addBtn.hasAttribute('data-mt-precio-en-boton')) {
              texto += ' · ' + formatMoney(variant.price);
            }
            addBtn.textContent = texto;
          } else {
            addBtn.disabled = true;
            addBtn.textContent = addBtn.getAttribute('data-mt-soldout-text') || 'Agotado';
          }
        }
        // Ficha nueva: cambiar de diapositiva en el visor.
        var galeriaPdp = gallerySection ? gallerySection.querySelector('[data-mt-galeria]') : null;
        if (!galeriaPdp) {
          galeriaPdp = document.querySelector('[data-mt-galeria]');
        }
        if (!primeraPasada && galeriaPdp && galeriaPdp.__mtMostrarPorSrc && variant.featured_image) {
          galeriaPdp.__mtMostrarPorSrc(variant.featured_image.src);
        }

        document.dispatchEvent(new CustomEvent('mt:variante-actualizada'));

        if (galleryMain && variant.featured_image && variant.featured_image.src) {
          var newSrc = variant.featured_image.src;
          if (galleryMain.src !== newSrc) {
            galleryMain.src = newSrc;
          }
          if (galleryThumbs && galleryThumbs.length) {
            var matched = false;
            galleryThumbs.forEach(function (t) {
              var full = t.getAttribute('data-mt-full') || '';
              var isMatch = full.split('?')[0] === newSrc.split('?')[0];
              t.classList.toggle('is-active', isMatch);
              if (isMatch) matched = true;
            });
            if (!matched) {
              galleryThumbs.forEach(function (t) { t.classList.remove('is-active'); });
            }
          }
        }
      }

      swatches.forEach(function (btn) {
        var evento = btn.tagName === 'INPUT' ? 'change' : 'click';
        btn.addEventListener(evento, function () {
          if (btn.disabled) return;
          if (btn.tagName !== 'INPUT') {
            var idx = btn.getAttribute('data-mt-option-index');
            document.querySelectorAll('[data-mt-option-index="' + idx + '"]').forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');
          }
          updateUI();
        });
      });

      updateUI();
      primeraPasada = false;
    });
  }

  /* ---------- Cantidad ---------- */
  function initQty() {
    document.querySelectorAll('[data-mt-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('[data-mt-qty-minus]');
      var plus = wrap.querySelector('[data-mt-qty-plus]');
      if (!input) return;
      minus && minus.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      plus && plus.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  /* ---------- Vídeos verticales ---------- */
  function initVideos() {
    var frames = document.querySelectorAll('.mt-videos__frame');
    if (!frames.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    frames.forEach(function (frame) {
      var video = frame.querySelector('video');
      var sound = frame.querySelector('[data-mt-video-sound]');
      if (!video) {
        if (sound) sound.hidden = true;
        return;
      }

      // Autoplay silencioso solo funciona con estas tres propiedades.
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      // Ralentizar el vídeo alarga cada vuelta del bucle, así el salto al
      // volver a empezar se nota mucho menos en clips cortos.
      var velocidad = parseFloat(frame.getAttribute('data-mt-video-velocidad'));
      if (velocidad > 0) {
        video.defaultPlaybackRate = velocidad / 100;
        video.playbackRate = velocidad / 100;
      }
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');

      var iconOff = sound && sound.querySelector('[data-mt-sound-off]');
      var iconOn = sound && sound.querySelector('[data-mt-sound-on]');

      if (sound) {
        sound.addEventListener('click', function () {
          video.muted = !video.muted;
          if (iconOff) iconOff.hidden = !video.muted;
          if (iconOn) iconOn.hidden = video.muted;
          sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          if (!video.muted && video.paused) video.play().catch(function () {});
        });
      }

      if (reduce || !('IntersectionObserver' in window)) return;

      // Al cargar la página el vídeo puede no tener datos suficientes todavía y
      // play() se rechaza en silencio. Guardamos la intención y reintentamos en
      // cuanto el navegador avisa de que ya puede reproducir.
      var deberiaReproducir = false;
      function intentarReproducir() {
        if (!deberiaReproducir) return;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      video.addEventListener('canplay', intentarReproducir);
      video.addEventListener('loadeddata', intentarReproducir);

      // Reproduce solo cuando el vídeo está a la vista: ahorra datos y batería.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            deberiaReproducir = true;
            intentarReproducir();
          } else {
            deberiaReproducir = false;
            video.pause();
          }
        });
      }, { threshold: 0.35 });
      io.observe(frame);
    });
  }

  /* ---------- Modelo 3D del producto ---------- */
  function initModelo3d() {
    var cajas = document.querySelectorAll('[data-mt-modelo]');
    if (!cajas.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    cajas.forEach(function (caja) {
      var mv = caja.querySelector('model-viewer');
      if (!mv) return;

      // Encuadre y luz. La altura de cámara (94°) es la clave: mira un pelín
      // desde abajo, que es donde se ve el foco encendido bajo el disco.
      mv.removeAttribute('camera-controls');
      mv.setAttribute('interaction-prompt', 'none');
      mv.setAttribute('environment-image', 'neutral');
      mv.setAttribute('tone-mapping', 'neutral');
      mv.setAttribute('shadow-intensity', '0.45');
      mv.setAttribute('shadow-softness', '1');
      mv.setAttribute('exposure', '1');
      mv.setAttribute('disable-zoom', '');
      mv.setAttribute('disable-pan', '');
      mv.setAttribute('disable-tap', '');
      mv.setAttribute('touch-action', 'pan-y');

      var ALTURA = '94deg';
      var DISTANCIA = '0.92m';
      var angulo = 20;
      mv.setAttribute('camera-orbit', angulo + 'deg ' + ALTURA + ' ' + DISTANCIA);

      if (reduce) return;

      // Giro continuo movido a mano: así no depende de que el visor tenga
      // activado su propio auto-rotate, y no hace falta tocar con el ratón.
      var animando = false;
      var ultimo = 0;

      function paso(ahora) {
        if (!animando) return;
        var delta = ultimo ? (ahora - ultimo) / 1000 : 0;
        ultimo = ahora;
        angulo = (angulo + delta * 16) % 360; // 16°/s
        mv.setAttribute('camera-orbit', angulo + 'deg ' + ALTURA + ' ' + DISTANCIA);
        requestAnimationFrame(paso);
      }

      function arrancar() {
        if (animando) return;
        animando = true;
        ultimo = 0;
        requestAnimationFrame(paso);
      }
      function parar() { animando = false; }

      // Solo gira mientras se ve: ahorra batería y CPU.
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (e) { e.isIntersecting ? arrancar() : parar(); });
        }, { threshold: 0.1 }).observe(caja);
      } else {
        arrancar();
      }

      document.addEventListener('visibilitychange', function () {
        document.hidden ? parar() : arrancar();
      });
    });
  }

  /* ---------- Añadir al carrito sin recargar (cajón lateral) ---------- */
  // Mi formulario es un <form> normal: al enviarlo, el navegador se va a la
  // página del carrito. Aquí se intercepta, se manda por detrás y se abre el
  // cajón lateral de Dawn con el contenido ya actualizado.
  function initCarritoLateral() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return; // el tema está en modo "página de carrito"

    document.querySelectorAll('[data-mt-product-form]').forEach(function (form) {
      var boton = form.querySelector('[data-mt-add-btn]');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (boton && boton.disabled) return;

        var textoOriginal = boton ? boton.textContent : '';
        if (boton) {
          boton.disabled = true;
          boton.setAttribute('aria-busy', 'true');
        }

        var datos = new FormData(form);
        // Shopify devuelve el HTML ya montado de estas secciones, que es lo que
        // el cajón necesita para repintarse sin recargar la página.
        var secciones = (cajon.getSectionsToRender ? cajon.getSectionsToRender() : [])
          .map(function (s) { return s.id; });
        if (secciones.length) {
          datos.append('sections', secciones.join(','));
          datos.append('sections_url', window.location.pathname);
        }

        fetch((window.routes && routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: datos
        })
          .then(function (r) { return r.json(); })
          .then(function (respuesta) {
            if (respuesta.status) {
              // Sin stock o combinación inválida: Shopify devuelve un error.
              if (boton) boton.textContent = respuesta.description || respuesta.message || 'No disponible';
              setTimeout(function () { if (boton) boton.textContent = textoOriginal; }, 2600);
              return;
            }
            if (cajon.classList) cajon.classList.remove('is-empty');
            if (cajon.renderContents) cajon.renderContents(respuesta);
            if (boton) boton.textContent = textoOriginal;
          })
          .catch(function () {
            // Si algo falla, se envía el formulario a la antigua para no dejar
            // al cliente sin poder comprar.
            form.submit();
          })
          .finally(function () {
            if (boton) {
              boton.disabled = false;
              boton.removeAttribute('aria-busy');
            }
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initComparador();
    initGaleria();
    initGaleriaPdp();
    initTramos();
    initVariantes();
    initQty();
    initVideos();
    initModelo3d();
    initCarritoLateral();
  });
})();
